export default __webpack_public_path__ + "images/3bce87edb4ed53e8022f663b262dc70c-newyearseve_small.webp";